import * as React from 'react';
import OrdersLayout from "../components/OrdersLayout"
 
const CompletedOrders: React.SFC = () => {
    return (  
        <OrdersLayout/>
    );
}
 
export default CompletedOrders;